import Rebase from 're-base';
import base from './base';

const rebase = Rebase.createClass( base.database() );

export default rebase;



/** WEBPACK FOOTER **
 ** ./src/rebase.js
 **/